import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { profile, trustMarks } from '../data/profile';
import { IndustryBackdrop } from '../components/IndustryBackdrop';
export function Home() {
  return <section className="relative overflow-hidden bg-ink-900 pt-32" data-id="element-188" data-mp="2x67lyqbm9apf">
      <IndustryBackdrop tone="dark" data-id="element-189" data-mp="2x7ipcp15ggg0" />
      <div className="absolute inset-y-0 left-0 w-1/3 bg-grass-900/40" aria-hidden="true" data-id="element-190" data-mp="1ziqulndwtwlq" />

      <div className="relative mx-auto max-w-[1400px] px-6 pb-16 lg:px-10 lg:pb-24" data-id="element-191" data-mp="24gilce2tjcoc">
        <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20" data-id="element-192" data-mp="29gdaac319s6r">
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-193" data-mp="2dhqjmw5c4dif">
            <p className="text-sm tracking-wider2 text-gold-300" data-id="element-194" data-mp="3kxmx98ldf2ct">
              {profile.title.toUpperCase()} · {profile.company.toUpperCase()}
            </p>
            <h1 className="mt-6 text-4xl leading-[1.12] text-white md:text-6xl" data-id="element-195" data-mp="30vgjsc74whmb">
              {profile.headline}
            </h1>
            <p className="mt-7 max-w-2xl text-xl leading-relaxed text-slate-300" data-id="element-196" data-mp="2vvvms7biyjc8">
              {profile.subheadline}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-197" data-mp="2mxjork8bwj9r">
              <Link to="/insights" className="inline-flex items-center gap-3 bg-grass-500 px-8 py-4 text-lg text-white transition-colors duration-150 ease-exec hover:bg-grass-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-300 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900" data-id="element-198" data-mp="2mzcyx9i5hlmi">
                View Case Studies
                <ArrowRightIcon className="h-5 w-5" data-id="element-199" data-mp="2376hdw3frruo" />
              </Link>
              <Link to="/contact" className="inline-flex items-center gap-3 border border-gold-400 px-8 py-4 text-lg text-gold-200 transition-colors duration-150 ease-exec hover:bg-gold-400 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900" data-id="element-200" data-mp="1z6wamh7tkxer">
                Get in Touch
              </Link>
            </div>

            <p className="mt-8 inline-flex items-center gap-2 text-base text-slate-400" data-id="element-201" data-mp="1fl4973svwu4m">
              <MapPinIcon className="h-4 w-4 text-gold-400" data-id="element-202" data-mp="23bgr97hug78x" />
              {profile.location}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="justify-self-center lg:justify-self-end" data-id="element-203" data-mp="2899vvw3i0t73">
            <figure className="relative" data-id="element-204" data-mp="2m9klywwzi3r7">
              <div className="absolute inset-0 translate-x-4 translate-y-4 border border-gold-400/50" aria-hidden="true" data-id="element-205" data-mp="2m8huonvr1zar" />
              <div className="relative border-[10px] border-grass-700 bg-grass-800 p-2" data-id="element-206" data-mp="fl0vi39plh07">
                <div className="border border-gold-400/70 p-1" data-id="element-207" data-mp="anissumaby0n">
                  <img src={profile.portrait} alt={`Portrait of ${profile.name}`} className="h-[340px] w-[340px] object-cover object-top md:h-[420px] md:w-[420px]" data-id="element-208" data-mp="akwjoqjqxagb" />
                </div>
              </div>
              <figcaption className="relative mt-6 border-l-2 border-gold-400 pl-4 text-slate-300" data-id="element-209" data-mp="3sugbf8l70zv4">
                <span className="block text-xl text-white" data-id="element-210" data-mp="3nvc4yppnlg8h">{profile.name}</span>
                <span className="block text-base" data-id="element-211" data-mp="5p7hefgcdfgb">
                  {profile.title}, {profile.company}
                </span>
              </figcaption>
            </figure>
          </motion.div>
        </div>
      </div>

      <div className="relative border-t border-white/10 bg-ink-800/80" data-id="element-212" data-mp="1h4w4d6tlieh4">
        <dl className="mx-auto grid max-w-[1400px] grid-cols-2 divide-white/10 px-6 lg:grid-cols-5 lg:divide-x lg:px-10" data-id="element-213" data-mp="1c2x445t5jxoe">
          {trustMarks.map(mark => <div key={mark.label} className="px-2 py-7 lg:px-8" data-id="element-214" data-mp="2ccg6qoy9soq8">
              <dd className="text-2xl text-gold-300" data-id="element-215" data-mp="2ceszlx5kgji2">{mark.value}</dd>
              <dt className="mt-1 text-sm tracking-wider2 text-slate-400" data-id="element-216" data-mp="2hahqlc3iss2r">
                {mark.label.toUpperCase()}
              </dt>
            </div>)}
        </dl>
      </div>
    </section>;
}